import React from "react";

import { Text, HStack } from "@chakra-ui/react";

export const Dia = ({ nome, horarios }) => {
  return (
    <HStack>
      <Text fontWeight={500} fontSize="9px" lineHeight="15px" color="#797A80">
        {nome}
      </Text>
      <HStack>
        {horarios?.length > 0 &&
          horarios
            .filter((horario) => !!horario.start)
            .map((horario, index) => {
              return (
                <Text
                  key={index}
                  fontWeight={500}
                  fontSize="9px"
                  lineHeight="15px"
                  color="#797A80"
                >
                  {index !== horarios.length - 1
                    ? `${horario.start} - ${horario.end}, `
                    : `${horario.start} - ${horario.end};`}
                </Text>
              );
            })}
      </HStack>
    </HStack>
  );
};
